import { render, staticRenderFns } from "./TheSysList.vue?vue&type=template&id=38b24ae2&scoped=true&"
import script from "./TheSysList.vue?vue&type=script&lang=js&"
export * from "./TheSysList.vue?vue&type=script&lang=js&"
import style0 from "./TheSysList.vue?vue&type=style&index=0&id=38b24ae2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b24ae2",
  null
  
)

export default component.exports